<template>
    <b-modal ref="modal" centered :visible="true" @hidden="onModalHidden">
        <template slot="modal-header">
            {{ Translations.buttons.createBox }}
        </template>
        <template>
            <b-form class="form" @submit.prevent="createBox">
                <input type="hidden" id="stationUid" name="stationUid" v-model="boxData.stationUid" />
                <div class="linked-properties">
                    <b-form-group id="group-name" :label="Translations.labels.name" label-for="name" :label-cols="4">
                        <b-form-input autofocus id="name" name="name" v-model="boxData.name" type="text" required autocomplete="off" :placeholder="Translations.placeholders.name" />
                    </b-form-group>
                    <b-form-group id="color-container" :label="Translations.labels.color" label-for="colorCode" :label-cols="4">
                        <b-form-input id="name" name="colorCode" v-model="boxData.colorCode" type="color" :placeholder="Translations.placeholders.color" />
                    </b-form-group>
                </div>
              <div >
                <!--                        <span class="detail-label">Style(s)</span>-->
                <b-form-group id="group-style" :label="'Styles'" label-for="style" :label-cols="4">
                  <StyleBadgeList
                      :styles="boxData.styles"
                      ref="styles"
                      :readOnly="true"
                      placeholder
                      @onFocus="onFocus('styles')"
                      @onBlur="onBlur"
                      @click.prevent="openParameterSelector('showStyleSelector','modalStyles', [boxData])"
                  />
                  <!--                        <span class="detail-error">This field is required</span>-->
                </b-form-group>
              </div>
              <div >
                <b-form-group id="group-categories" :label="'Categories'" label-for="categories" :label-cols="4">
                  <!--                        <span class="detail-label">categories</span>-->
                  <StyleBadgeList
                      :styles="boxData.categories"
                      ref="styles"
                      :readOnly="true"
                      placeholder
                      @onFocus="onFocus('categories')"
                      @onBlur="onBlur"
                      @click.prevent="openParameterSelector('showCategoriesSelector','modalCategories', [boxData])"
                  />
                  <!--                        <span class="detail-error">This field is required</span>-->
                </b-form-group>
              </div>
              <div >
                <b-form-group id="group-targets" :label="'Targets'" label-for="targets" :label-cols="4">
                  <!--                        <span class="detail-label">Targets</span>-->
                  <StyleBadgeList styles=""
                                  :styles="boxData.targets"
                                  ref="styles"
                                  :readOnly="true"
                                  placeholder
                                  @onFocus="onFocus('targets')"
                                  @onBlur="onBlur"
                                  @click.prevent="openParameterSelector('showTargetSelector','modalTargets', [boxData])"
                  />
                  <!--                        <span class="detail-error">This field is required</span>-->
                </b-form-group>
              </div>
                <div class="linked-properties">
                    <b-form-group :label="Translations.labels.boxType" label-for="boxType" :label-cols="4">
                        <b-form-radio-group id="boxType" name="type" v-model="boxData.type"
                                            :options="boxTypes">
                        </b-form-radio-group>
                    </b-form-group>
                    <b-form-group v-if="boxData.type == boxTypes.BOX.value" :label="Translations.labels.trackType" label-for="trackType" :label-cols="4">
                        <b-form-select id="trackType" name="trackType" v-model="boxData.trackType" :options="trackTypes" :placeholder="Translations.placeholders.trackType">
                        </b-form-select>
                    </b-form-group>
                </div>
            </b-form>
        </template>
        <template slot="modal-footer">
            <Button :empty="true" class="close-popup" @click.prevent="cancelModal">{{ Translations.buttons.cancel }} </Button>
            <Button :empty="false" class="validate" :disabled="!isFormValid" @click.prevent="createBox">{{ Translations.buttons.doCreateBox }} </Button>
        </template>
      <SelectorStyle
          v-show="viewState.showStyleSelector"
          ref="modalStyles"
          :stationUid="boxData.stationUid"
          :noModalEdit="true"
          @newValue="onNewValueStyles"
          @onHidden="resetModalState('showStyleSelector')"
      />
      <SelectorCategories
          v-show="viewState.showCategoriesSelector"
          ref="modalCategories"
          :stationUid="boxData.stationUid"
          :noModalEdit="true"
          @newValueCategories="onNewValueCategories"
          @onHidden="resetModalState('showCategoriesSelector')"
      />
      <SelectorTargets
          v-show="viewState.showTargetSelector"
          ref="modalTargets"
          :stationUid="boxData.stationUid"
          :noModalEdit="true"
          @newValueTargets="onNewValueTargets"
          @onHidden="resetModalState('showTargetSelector')"
      />
    </b-modal>
</template>
<script>
    import Vue from 'vue';
    import Button from'@/components/common/Button'
    import Bootstrap from 'bootstrap-vue';
    import store from '@/store';
    import router from '@/router';
    import Translations from '@/store/translations';
    import Constants from '@/store/constants';
    import EventBus from '@/eventbus';
    import Portlet from '@/components/common/Portlet.vue';
    import { HTTP } from "@/utils/http";
    import { mapState } from 'vuex';
    import StyleBadgeList from "@/components/common/StyleBadgeList";
    import SelectorStyle from "@/components/Library/SelectorStyle";
    import SelectorCategories from "@/components/Boxes/SelectorCategorie";
    import SelectorTargets from "@/components/Boxes/SelectorTarget";

    export default {
        name: "BoxCreationCard",
        store, router,
        components: { Portlet, Bootstrap, Button ,  StyleBadgeList, SelectorStyle , SelectorCategories , SelectorTargets },
        computed: {
            ...mapState(['currentStation']),
            Translations: function () { return Translations; },
            trackTypes: function () {
                switch (this.boxData.type) {
                    case Constants.boxTypes.BOX.value:
                        return [
                            Constants.trackTypes.MUSIC,
                            Constants.trackTypes.JINGLE,
                            // Constants.trackTypes.PROMO,
                            // Constants.trackTypes.VOICE_TRACK,
                            Constants.trackTypes.PODCAST,
                            //Constants.trackTypes.FILLER
                        ];
                    case Constants.boxTypes.PLAYLIST.value: return [Constants.trackTypes.UNDEFINED];
                    case Constants.boxTypes.SMARTBOX.value: return [Constants.trackTypes.MUSIC];
                    default: return null;
                }
            },
            boxTypes: function () {
                return Constants.boxTypes;
            }
            ,
            errorMessages: function (inputName) {
                if (this.creationResponse == null || this.creationResponse.errors == null) return [];
            },
            isFormValid() {
                const { name } = this.boxData;
                return name && name.trim().length;
            }
        },
        watch: {
            "boxData.boxType": function (val) {
                // console.log("Watch done!");
                // console.log("Track Types!", this.trackTypes);
                // console.log("Value !", this.trackTypes[0]);
                this.boxData.trackType = this.trackTypes[0].value;
            }
        },
        data() {
            var boxTypes = Constants.boxTypes;
            var trackTypes = Constants.trackTypes;
            let currentBoxType = boxTypes.BOX.value
            let currentTrackType = trackTypes.MUSIC.value

            if (this.$route.params && this.$route.params.boxType) {
                if (this.$route.params.boxType === 'UNDEFINED') {
                    currentBoxType = Constants.boxTypes['PLAYLIST'].value
                } else {
                    let trackType = Constants.trackTypes[this.$route.params.boxType]
                    if (trackType) {
                        currentTrackType = trackType.value
                    }

                    if (this.$route.query.smartBox === true) {
                        currentBoxType = Constants.boxTypes['SMARTBOX'].value
                    }
                }
            }

            return {
                modalState: {
                    show: true,
                    visible: true,
                },
                viewState: {
                  showStyleSelector: false,
                  showCategoriesSelector: false,
                  showTargetSelector: false,
                },
                boxData: {
                    stationUid: this.$store.state.currentStationUid,
                    name: "",
                    type: currentBoxType,
                    colorCode: "#ff6a00",
                    trackType: currentTrackType,
                    styles:'',
                    categories:'',
                    targets:'',
                },
                creationResponse: null
            }
        }
        , methods: {
            createBox() {
                if (this.isFormValid) {
                 this.boxData.categories = this.TransformDataCategories(this.boxData.categories);
                 this.boxData.styles = this.TransformDataStyles(this.boxData.styles);
                 this.boxData.targets = this.TransformDataTargets(this.boxData.targets);
                    HTTP.post("api/boxes/create", this.boxData)
                        .then(this.onBoxCreated, this.onBoxCreationError)
                        .then(function () {
                            console.log("End...")
                        });
                }
            },
            onBoxCreated(response) {
                this.creationResponse = response;
                if (this.creationResponse.status === 200) {
                    const newBox = this.creationResponse.data;
                    if (newBox != null && newBox.dataItem != null) {
                        router.push({ name: 'BoxDetails', params: { boxUid: newBox.dataItem.uid } });
                        store.dispatch('loadStationBoxes', this.currentStation.uid);
                        this.cancelModal();
                    }
                }
                else {
                    //let vue build the error messages
                }
                //this.cancelModal();
            },
            onBoxCreationError(response) {
                // console.log(response);
                this.creationResponse = response;
                // console.error(response);
            },
            cancelModal() { this.$refs['modal'].hide() },
            onModalHidden() { EventBus.$emit('onBoxCreationEnded'); },
        onFocus(field) {
          this.$set(this.viewState, "fieldFocused", field);
        },
        onBlur() {
          this.$set(this.viewState, "fieldFocused", null);
        },
        openParameterSelector(toggler, selectorName, tracks) {
          if (!tracks || tracks.length === 0) return;
          this.viewState[toggler] = true;

          try {
            var modalSelector = this.$refs[selectorName];

            if (modalSelector) {
              modalSelector.editForTracks(tracks);
            }
          } catch (e) {
            console.log("exc:", e);
          }
        },
        onNewValueTargets(field, value) {
          console.log(field, value);
          this.boxData.targets = value;
        },
        onNewValueCategories(field, value) {
          console.log(field, value);
          this.boxData.categories = value;
        },
        onNewValueStyles(field, value) {
          console.log(field, value);
          this.boxData.styles = value;
        },
        resetModalState(toggler) {

        },
        TransformDataCategories(data){
          let array = [];
          for (let i = 0; i < data.length; i++) {
            array.push({'categoryId': data[i].id });
          }
          return array;
        },
        TransformDataStyles(data){
          let array = [];
          for (let i = 0; i < data.length; i++) {
            array.push({'styleId': data[i].id });
          }
          return array;
        },
        TransformDataTargets(data){
          let array = [];
          for (let i = 0; i < data.length; i++) {
            array.push({'targetId': data[i].id });
          }
          return array;
        },
        }
    }
</script>
